// extracted by mini-css-extract-plugin
export default {"Shadow":"NewUser_Shadow__X3ye2"};